import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import Link from '../../Links/Link/Link';

const PolicyChangesComponent = ({ intl }) => {
  const privacyPolicy = intl.formatMessage({
    id: 'PolicyChange.privacyPolicy',
  });
  const termsOfService = intl.formatMessage({
    id: 'PolicyChange.termsOfService',
  });
  const supportMail = <a href="mailto:support@vansite.eu">support@vansite.eu</a>;

  return (
    <React.Fragment>
      <FormattedMessage id="PolicyChange.welcome" />
      <FormattedMessage
        id="PolicyChange.text"
        values={{
          privacyPolicy: (
            <Link to={{ name: 'StoryblokPage', params: { slug: 'privacy-policy' } }}>
              {privacyPolicy}
            </Link>
          ),
          termsOfService: (
            <Link to={{ name: 'StoryblokPage', params: { slug: 'terms-of-service' } }}>
              {termsOfService}
            </Link>
          ),
          supportMail,
        }}
      />
      <FormattedMessage id="PolicyChange.greeting" />
    </React.Fragment>
  );
};

const PolicyChanges = injectIntl(PolicyChangesComponent);

export default PolicyChanges;
